import axios, { AxiosError } from "axios";
import config from "config";

import { api } from "config/urls";
import { ParsedQuery } from "query-string";

import { formatUrl } from "utils";

export interface LinkApiService {
  getCustomRedirect: ({
    companyId,
    params,
  }: GetCustomRedirectQuery) => Promise<CustomRedirectResponse>;
}

const axiosInstance = axios.create({
  withCredentials: true,
  headers: { "Content-Type": "application/json;charset=UTF-8" },
  baseURL: config.LINK_API_URL,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

type GetCustomRedirectQuery = {
  companyId: string;
  params: ParsedQuery;
};

type CustomRedirectResponse =
  | {
      hasCustomRedirect: true;
      customRedirectUrl: string;
    }
  | {
      hasCustomRedirect: false;
    };

export const makeLinkApiService = (): LinkApiService => {
  const getCustomRedirect: LinkApiService["getCustomRedirect"] = ({
    companyId,
    params,
  }) => {
    return axiosInstance
      .get(
        formatUrl(
          api.companies.customRedirect,
          {
            companyId,
          },
          params
        )
      )
      .then((d) => d.data);
  };

  return {
    getCustomRedirect,
  };
};
